import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Detailed General Ledger";
const description = `The Detailed General Ledger Report (or General Ledger Detail) is the most granular financial record, providing a complete audit trail for every transaction within a specified period. This report lists every single journal entry made to a particular account, including the transaction date, the unique reference or journal number, a full description or narrative, and the precise debit and credit amounts, which is crucial for auditors, accountants, and anyone performing in-depth reconciliation or discrepancy investigation.`;

const images = [
    '/images/reports/purchase-by-supplier/purchase-by-supplier.png', // 0
];


const DetailedGeneralLedger: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailedGeneralLedger;
